import { z } from 'zod';
/** Pick up an item lying on the ground. The server walks the player there if needed. */
export const PickupMessageSchema = z.object({ dropId: z.string().min(1).max(64) });
/** How long a drop stays on the ground before the zone cleans it up. */
export const DROP_TTL_MS = 60_000;
/** How long before it is swept away a drop blinks, so a full bag sees what it is about to lose. */
export const DROP_FADE_MS = 10_000;
//# sourceMappingURL=loot.js.map